import { Injectable } from '@angular/core';

import { map, Observable } from 'rxjs';

import type {
  ActionResolutionItem,
  BannerSlot,
  BannerSuggestion,
  ResolvedResultLink,
} from '@core/tellent-assistant-types';
import { injectTellentIntelligenceHttp } from '@core/tellent-http-legacy';

@Injectable({ providedIn: 'root' })
export class TellentAssistantHttp {
  private readonly httpApi = injectTellentIntelligenceHttp();

  public fetchSuggestions(slot: BannerSlot): Observable<readonly BannerSuggestion[]> {
    const body = { slot: slot.slot, params: 'params' in slot ? slot.params : {} };
    return this.httpApi
      .post('/tellent-assistant/suggestions', null, body)
      .pipe(map((response): readonly BannerSuggestion[] => response.data));
  }

  public recordEngagement(id: string): Observable<void> {
    return this.httpApi
      .post('/tellent-assistant/engagements', null, { id })
      .pipe(map(() => undefined));
  }

  public executeAction(
    threadId: string,
    proposalId: string,
    action: string,
    params: Record<string, unknown>,
  ): Observable<{ result?: unknown; resultLink?: ResolvedResultLink | null }> {
    return this.httpApi.post('/tellent-assistant/actions', null, {
      thread_id: threadId,
      proposal_id: proposalId,
      action,
      params,
    });
  }

  public cancelAction(threadId: string, proposalId: string): Observable<void> {
    return this.httpApi
      .post('/tellent-assistant/actions/cancel', null, {
        thread_id: threadId,
        proposal_id: proposalId,
      })
      .pipe(map(() => undefined));
  }

  public fetchActionResolutions(threadId: string): Observable<ActionResolutionItem[]> {
    return this.httpApi
      .post('/tellent-assistant/action-resolutions', null, { thread_id: threadId })
      .pipe(map((response: { items?: ActionResolutionItem[] }) => response.items ?? []));
  }
}
